import { gql, QueryResult, useQuery } from '@fluentsms/graphql';
import { IntrospectionQuery } from 'graphql';

const GET_MERGE_DATA_SCHEMA = gql`
  {
    mergeDataSchema
  }
`;

export const useSchema = (): QueryResult<IntrospectionQuery> => {
  const queryRes = useQuery(GET_MERGE_DATA_SCHEMA);
  return {
    ...queryRes,
    data: queryRes.data ? queryRes.data.mergeDataSchema : queryRes.data, // put the introspection data at the root
  };
};
